import {Module} from "../common/Module";
import {Nullable} from "../common/Nullable";
import {AuthenticatedUser} from "../users/AuthenticatedUser";
import {isPrivileged, isPrivilegedByIdentifier} from "../../config/Privileges";
import {ACCOUNTING_AREA_TYPE_NAME} from "./AccountBook";


export const OutgoingInvoicePaymentModule: Module = {
    identifier: 'outgoing-invoice-payment',
    isPrivileged: ( authUser: Nullable< AuthenticatedUser >, privilege: string, privilegeIdentifier?: string ) => {

        if( typeof privilegeIdentifier !== "undefined" ) {
            return isPrivilegedByIdentifier( authUser, privilegeIdentifier );
        } else {
            return isPrivileged(
                authUser,
                ACCOUNTING_AREA_TYPE_NAME,
                OutgoingInvoicePaymentModule.identifier,
                privilege
            );
        }
    }
};